import { guardClient } from '../_axios'

/**
 * カラム名更新
 * [put]/tasks/columns/{id}
 */
export type UpdateColumnRequest = {
  id: string
  title: string
}

export const updateColumn = async (request: UpdateColumnRequest) => {
  const { id, ...params } = request
  const path = '/tasks/columns'
  const response = await guardClient.put(path + '/' + id, params)
  return response.data
}
